import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Form, TextArea } from "semantic-ui-react";
import ModalWrapper from "../../../app/common/modals/modalWrapper";
import { closeModal } from "../../../app/common/modals/modalSlice";
import { addDocumentComment } from "./docCommentsActions";

export default function DocCommentCreateModal({
  documentId,
  transactionId,
  pageNumber,
  x,
  y,
  clickX,
  clickY,
}) {
  const dispatch = useDispatch();
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!comment.trim()) {
      return;
    }

    setLoading(true);
    
    const commentData = {
      documentId,
      transactionId,
      pageNumber,
      x,
      y,
      comment: comment.trim(),
    };

    try {
      await dispatch(addDocumentComment(commentData));
      dispatch(closeModal());
    } catch (error) {
      console.error("Error creating comment:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    dispatch(closeModal());
  };

  return (
    <ModalWrapper
      size="small"
      header="Add Comment"
      style={{
        position: "fixed",
        left: Math.min(clickX, window.innerWidth - 400),
        top: Math.min(clickY, window.innerHeight - 300),
      }}
    >
      <Form onSubmit={handleSubmit}>
        <Form.Field>
          <label>Comment</label>
          <TextArea
            placeholder="Enter your comment..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={4}
            maxLength={1000}
            autoFocus
          />
          <div style={{ textAlign: "right", fontSize: "0.8em", color: "#666" }}>
            {comment.length}/1000 characters
          </div>
        </Form.Field>
        
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
          <Button
            type="button"
            onClick={handleCancel}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            primary
            loading={loading}
            disabled={!comment.trim() || loading}
          >
            Save Comment
          </Button>
        </div>
      </Form>
    </ModalWrapper>
  );
}
